const Footer = () => {
    return ( 
        <div className="Footer">
            <p className="footerText">Made with ❤️ by <a href="https://x.com/AdeleyeOlu89360#:~:text=Edit%20profile-,Ol%C3%BAw%C3%A0m%C3%A2y%C3%B5w%C3%A1,-%40AdeleyeOlu89360" className="footerLink">Olúwàmâyõwá</a></p>
        </div>
     );
}
 
export default Footer;